import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to get the current user's first/primary facility
 * This facility is displayed in the sidebar header when the user is logged in
 *
 * @returns Object containing facility info and loading state
 */
export const useCurrentFacility = () => {
	const { user, isLoading, isAuthenticated } = useAuth();

	const currentFacility = useMemo(() => {
		if (!user || !user.facilities || user.facilities.length === 0) {
			return null;
		}
		return user.facilities[0];
	}, [user]);

	return {
		/** The user's primary facility (first in the list) */
		facility: currentFacility,
		/** The facility name, or null if not available */
		facilityName: currentFacility?.name || null,
		/** The facility ID, or null if not available */
		facilityId: currentFacility?.facilityId || null,
		/** Whether the auth state is still loading */
		isLoading,
		/** Whether the user is authenticated */
		isAuthenticated,
		/** Whether the user has any facilities */
		hasFacilities: (user?.facilities?.length || 0) > 0
	};
};
